import { render, staticRenderFns } from "./PqtEdit.vue?vue&type=template&id=4f95a389"
import script from "./PqtEdit.vue?vue&type=script&lang=ts"
export * from "./PqtEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports